import React, { Component, PropTypes } from 'react';

import './InlineEdit.scss';


class InlineEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            text: props.text,
            oldText: null,
        };
    }

    componentWillReceiveProps(props) {
        if (this.state.isEditing) return;

        this.setState({
            text: props.text,
        });
    }

    handleKeyDown(event) {
        if (event.key === 'Escape') {
            this.cancelEdit();
        } else if (event.key === 'Enter') {
            this.finishEdit();
        }

        event.stopPropagation();
    }

    startEdit() {
        if (this.state.isEditing) return;

        this.setState({
            isEditing: true,
            oldText: this.state.text,
        });
    }

    finishEdit() {
        const text = this.state.text.trim();
        this.setState({
            text,
            isEditing: false,
            oldText: null,
        });

        this.props.updateState(text);
    }

    cancelEdit() {
        this.setState({
            isEditing: false,
            text: this.state.oldText,
        });
    }

    render() {
        const { isEditing, text } = this.state;
        let component;
        if (isEditing) {
            component = (
                <input
                    value={text}
                    onChange={event => this.setState({ text: event.target.value })}
                    onBlur={() => this.finishEdit()}
                    onKeyDown={event => this.handleKeyDown(event)}
                    autoFocus
                />
            );
        } else {
            component = (
                <span onClick={() => this.startEdit()}>{text}</span>
            );
        }

        return (
            <div
                className="inline-edit"
            >
                {component}
            </div>
        );
    }
}

InlineEdit.propTypes = {
    text: PropTypes.string.isRequired,
    updateState: PropTypes.func.isRequired,
};

export default InlineEdit;



/** WEBPACK FOOTER **
 ** ./client/components/InlineEdit/InlineEdit.jsx
 **/